import styles from './LoadingScreen.module.css'

export default function LoadingScreen({ message = 'Loading PatientTrac Mind...' }) {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#0f3d5c"/>
            <path d="M24 10C24 10 14 16 14 25C14 30.5 18.5 35 24 35C29.5 35 34 30.5 34 25C34 16 24 10 24 10Z" fill="#1a8a7b" opacity="0.8"/>
            <path d="M20 24H28M24 20V28" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </div>
        <h2 className={styles.brand}>PatientTrac <em>Mind</em></h2>
        <div className={styles.spinner}>
          <div className={styles.track} />
          <div className={styles.bar} />
        </div>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  )
}
